import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { SocFormField } from 'components/Assessments/SocAssessment/types/SocFormField'
import { SocAssessmentQuestionnaireItem } from 'components/Assessments/SocAssessment/types/questionnaire'

/**
 * Final Steps subsection adapter for SOC Assessment
 * Handles final steps extraction and transformation
 */
export class FinalStepsAdapter extends BaseSubsectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<SocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalStepsInternalNotes = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
    )?.at(0)
    const pendingRequiredDocumentation =
      getAnswerValuesFromItems(
        flatAnswersArray,
        SocAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION
      ) || []

    return {
      [SocFormField.FINAL_STEPS_INTERNAL_NOTES]: finalStepsInternalNotes,
      [SocFormField.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION]: pendingRequiredDocumentation
    }
  }

  buildFlatAnswers(): Array<{ linkId: string; value: unknown }> {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(SocFormField.FINAL_STEPS_INTERNAL_NOTES)) {
      mutations.push({
        linkId: SocAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES,
        value: this.getFormDataField(SocFormField.FINAL_STEPS_INTERNAL_NOTES)
      })
    }

    if (this.formDataFieldExists(SocFormField.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION)) {
      mutations.push({
        linkId: SocAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION,
        value: this.getFormDataField(SocFormField.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION)
      })
    }

    return mutations
  }
}
